import * as React from "react"
import { Slot } from "@radix-ui/react-slot"
import { cva, type VariantProps } from "class-variance-authority"

import { cn } from "@/lib/utils"

const buttonVariants = cva(
  // focus-visible:ring-2 + ring-offset-2 substitui o ring-1 anterior — 1px
  // somia sobre o primary laranja e reprovava WCAG 2.2 SC 2.4.13 (indicador
  // ≥2px). Mantém o ring-ring (cor primária da loja) com offset pra contornar
  // o botão em vez de empilhar.
  "inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0" +
" hover-elevate active-elevate-2",
  {
    variants: {
      variant: {
        default:
           // @replit: no hover, and add primary border
           "bg-primary text-primary-foreground border border-primary-border",
        destructive:
          "bg-destructive text-destructive-foreground shadow-sm border-destructive-border",
        outline:
          // @replit Shows the background color of whatever card / sidebar / accent background it is inside of.
          // Inherits the current text color. Uses shadow-xs. no shadow on active
          // No hover state
          " border [border-color:var(--button-outline)] shadow-xs active:shadow-none ",
        secondary:
          // @replit border, no hover, no shadow, secondary border.
          "border bg-secondary text-secondary-foreground border border-secondary-border ",
        // @replit no hover, transparent border
        ghost: "border border-transparent",
        link: "text-primary underline-offset-4 hover:underline",
      },
      // Cada tamanho ganha um floor de 44px (min-h-11) APENAS quando o input
      // primário é "coarse" (dedo/toque). Em desktop com mouse, mantém a
      // densidade original — admin precisa caber muita coisa na tela. Key
      // é por device (pointer:coarse), não por viewport (md:): tablet em
      // modo paisagem ainda é dedo e precisa de target grande.
      size: {
        default: "min-h-9 pointer-coarse:min-h-11 px-4 py-2",
        sm: "min-h-8 pointer-coarse:min-h-11 rounded-md px-3 text-xs",
        lg: "min-h-10 pointer-coarse:min-h-11 rounded-md px-8",
        icon: "h-9 w-9 pointer-coarse:h-11 pointer-coarse:w-11",
      },
    },
    defaultVariants: {
      variant: "default",
      size: "default",
    },
  }
)

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {
  asChild?: boolean
}

const Button = React.forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? Slot : "button"
    return (
      <Comp
        className={cn(buttonVariants({ variant, size, className }))}
        ref={ref}
        {...props}
      />
    )
  }
)
Button.displayName = "Button"

export { Button, buttonVariants }
